export default [
  '$scope', '$timeout', 'UserDataService', 'CobrandedAPISerice', 'ErrorHandler',
  class CobrandImportCtrl {
    constructor($scope, $timeout, UserDataService, CobrandedAPISerice, ErrorHandler) {
      this._$scope = $scope;
      this._$timeout = $timeout;
      this._cobrandedAPIService = CobrandedAPISerice;
      this._errorHandler = ErrorHandler;
      this._userDataService = UserDataService;

      this._checkIfUserLoggedIn();
      this._initFileEvents();
      this.failuresArray = {};
    }

    uploadFile(file) {
      let formData = new FormData();
      formData.append('import_csv', file);
      return this._cobrandedAPIService.uploadFile(this._userDataService.user.cobranding_partner_id, formData);
    }

    formatDate(date) {
      return moment.utc(date).local().format(`MM/DD/YY h:mm`);
    }

    _checkIfUserLoggedIn() {
      this.processing = true;
      this._userDataService.getUserData()
        .then(res => {
          if (res.user.roles === 'COBRAND-ADMIN') {
            this._getImportHistory();
          }
        })
        .finally(err => this.processing = false);
    }

    _getImportHistory() {
      this._cobrandedAPIService.getImportHistory(this._userDataService.user.cobranding_partner_id)
        .then(res => {
          this.jobHistory = res.imports;

          _.forEach(this.jobHistory, (job) => {
            if (job.status === "DONE_WITH_ERRORS" && !this.failuresArray[job.id]) {
              this._getImportHistoryDetails(job);
            } else if (job.status === "PROCESSING") {
              this._$timeout(() => this._getImportHistoryDetails(job), 1000);
            }
          });
        })
        .catch(err => this._errorHandler.throwError('Import History Error', 'An error occurred while attempting to retrieve import history. Please try again later.', { rawError: err }));
    }
    
    _getImportHistoryDetails(job) {
      this._cobrandedAPIService.getImportStatus(this._userDataService.user.cobranding_partner_id, job.id)
        .then(res => {
          this.failuresArray[job.id] = res.failures;
          job.status = res.status;
          if (job.status === "PROCESSING") {
            this._$timeout(() => this._getImportHistoryDetails(job), 1000);
          }
        })
        .catch(err => this._errorHandler.throwError('Import History Details Error', 'An error occurred while attempting to retireve import history details. Please try agian later.', { rawError: err }));
    }


    _initFileEvents() {
      this._$scope.$on('file-upload:file-selected', (e, file) => {
        this.processing = true;
        this.uploadFile(file)
          .then(res => this._getImportHistory())
          .catch(err => this._errorHandler.throwError('File Upload Error', 'An error occurred while attempting to upload file. Please try again later.', { rawError: err }))
          .finally(() => this.processing = false);
      });
    }
  }
]


// WEBPACK FOOTER //
// ./source/client/pages/cobrand/cobrand-admin/cobrand-admin-import/cobrand-admin-import.ctrl.js